import { render } from "./FileRegistry.vue?vue&type=template&id=357a4ccc&scoped=true"
import script from "./FileRegistry.vue?vue&type=script&lang=js"
export * from "./FileRegistry.vue?vue&type=script&lang=js"

import "./FileRegistry.vue?vue&type=style&index=0&id=357a4ccc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357a4ccc"]])

export default __exports__